import { render, staticRenderFns } from "./CheckoutPayment.vue?vue&type=template&id=5991b598"
import script from "./CheckoutPayment.vue?vue&type=script&lang=js"
export * from "./CheckoutPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports